// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Edit Satellite menu (v13+) tweaks.
 *
 * This is a dense form: each card stacks several Materialize fields whose
 * floating "active" label sits ~14px above its input, so the shared-stylesheet
 * defaults are corrected here, scoped to this menu. All action rows live inside
 * .kt-section cards, so the standalone-action width rule is not needed.
 */

/*
 * 1. Stacked-field headroom. The shared v13 default
 *    (\`.kt-field-row .input-field.col { margin-top: 6px }\`) is too tight when a
 *    card stacks more than one labelled row; the floating label collides with
 *    the row above. Give every stacked row room for the label to clear.
 */
#editSat-menu .kt-field-row .input-field.col {
  margin-top: 20px;
}

/*
 * The first row in a card sits directly under the section label, which already
 * provides separation, so it does not need the full floating-label headroom.
 */
#editSat-menu .kt-section-label + .kt-field-row .input-field.col {
  margin-top: 8px;
}

/*
 * 2. Focus indication. KeepTrack marks field focus with an underline, not a box.
 *    The app-wide \`:focus-visible\` rule otherwise draws a 2px outline (offset
 *    2px) that overlaps the floating label above each field. Swap the box for a
 *    primary-colored underline so the indicator stays inside the field.
 */
#editSat-menu .input-field input:focus,
#editSat-menu .input-field textarea:focus {
  border-bottom-color: var(--color-primary) !important;
  box-shadow: 0 1px 0 0 var(--color-primary);
}

#editSat-menu .input-field input:focus-visible,
#editSat-menu .input-field textarea:focus-visible {
  outline: none;
}

/* Inline submit-error note: red surface, dismissible on click. */
#editSat-menu #es-error {
  margin: 0 6px 8px;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  color: var(--color-light-text, #fff);
  background-color: var(--color-error, #b00020);
}
`, "",{"version":3,"sources":["webpack://./src/plugins/edit-sat/edit-sat.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;;;;;EAKE;AACF;EACE,gBAAgB;AAClB;;AAEA;;;EAGE;AACF;EACE,eAAe;AACjB;;AAEA;;;;;EAKE;AACF;;EAEE,oDAAoD;EACpD,0CAA0C;AAC5C;;AAEA;;EAEE,aAAa;AACf;;AAEA,iEAAiE;AACjE;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,6CAA6C;AAC/C","sourcesContent":["/**\n * Edit Satellite menu (v13+) tweaks.\n *\n * This is a dense form: each card stacks several Materialize fields whose\n * floating \"active\" label sits ~14px above its input, so the shared-stylesheet\n * defaults are corrected here, scoped to this menu. All action rows live inside\n * .kt-section cards, so the standalone-action width rule is not needed.\n */\n\n/*\n * 1. Stacked-field headroom. The shared v13 default\n *    (`.kt-field-row .input-field.col { margin-top: 6px }`) is too tight when a\n *    card stacks more than one labelled row; the floating label collides with\n *    the row above. Give every stacked row room for the label to clear.\n */\n#editSat-menu .kt-field-row .input-field.col {\n  margin-top: 20px;\n}\n\n/*\n * The first row in a card sits directly under the section label, which already\n * provides separation, so it does not need the full floating-label headroom.\n */\n#editSat-menu .kt-section-label + .kt-field-row .input-field.col {\n  margin-top: 8px;\n}\n\n/*\n * 2. Focus indication. KeepTrack marks field focus with an underline, not a box.\n *    The app-wide `:focus-visible` rule otherwise draws a 2px outline (offset\n *    2px) that overlaps the floating label above each field. Swap the box for a\n *    primary-colored underline so the indicator stays inside the field.\n */\n#editSat-menu .input-field input:focus,\n#editSat-menu .input-field textarea:focus {\n  border-bottom-color: var(--color-primary) !important;\n  box-shadow: 0 1px 0 0 var(--color-primary);\n}\n\n#editSat-menu .input-field input:focus-visible,\n#editSat-menu .input-field textarea:focus-visible {\n  outline: none;\n}\n\n/* Inline submit-error note: red surface, dismissible on click. */\n#editSat-menu #es-error {\n  margin: 0 6px 8px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  color: var(--color-light-text, #fff);\n  background-color: var(--color-error, #b00020);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
